import React, { Component, useRef, useState, useEffect } from 'react';
import {Link, useNavigate, useParams } from "react-router-dom";
import NavBarMini from './NavBarMini.js';
import Footer from './Footer.js';
import LoadingAnimation from './LoadingAnimation.js';
import * as utils from '../common/Utils.js'
import { useConfig } from '../contexts/ConfigContext.js';
import { useAdminGuard } from '../hooks/useAdminGuard.js';

import { collection, query, where, getDoc, getDocs, setDoc, updateDoc, doc, Timestamp } from "firebase/firestore";
import { db } from '../firebase.js';

let DATE_WHEN_BLOCKS_AND_STEALS_WERE_ADDED = new Date('May 27, 2024');
let SAVE_BLOCKS_AND_STEALS = true;

const AdminTeams = () => {
  const navigate = useNavigate();
  const config = useConfig();
  const { currentUser, isReady } = useAdminGuard();
  const { teamID, id } = useParams();
  const [teams, setTeams] = useState([]);
  const [dataReady, setDataReady] = useState(false);
  const [team, setTeam] = useState({})

  useEffect(() => {
    if (!isReady) return;

    getTeams();
  }, [isReady]); // eslint-disable-line react-hooks/exhaustive-deps

  const getTeams = async () => {
    const teamsRef = collection(db, "teams");
    const teamsSnapshot = await getDocs(teamsRef);
    const teamsData = teamsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));

    if (teamID) {
      const tm = utils.getTeamForID(teamsData, teamID)

      setTeam(tm)
    }

    setTeams(teamsData);
    setDataReady(true);
  }

  function displayTeams () {
    const teamsDisplay = teams.map((tm) => displayTeam(tm))

    return teamsDisplay
  }

  function displayTeam (tm) {
    return (
      <div className="large-item-button" onClick={() => navigate(`/admin/teams/${tm.id}`)}>
        <h2>{ tm.name }</h2>
        <p>{ tm.nameAbbv }</p>
      </div>
    )
  }

  function displayEditTeam () {
    return (
      <>
        <form>
          <div className="form-row">
            <div className="form-group">
              <label for="inputTeamName">Team Name</label>
              <input type="text" className="form-control" id="inputTeamName" defaultValue={ team.name } required></input>
            </div>
            <div className="form-group">
              <label for="inputTeamNameAbbv">Team Name Abbreviated</label>
              <input type="text" className="form-control" id="inputTeamNameAbbv" defaultValue={ team.nameAbbv } required></input>
            </div>
          </div>
          <div className="form-group">
            <label for="inputTeamID">ID</label>
            <input type="text" className="form-control" id="inputTeamID" defaultValue={ team.id } required disabled={ teamID ? 'true' : 'false' }></input>
          </div>
          <div className="form-group">
            <label for="inputTeamBio">Bio</label>
            <textarea type="text" className="form-control" id="inputTeamBio" defaultValue={ (team.bio || []).join('\n') } required></textarea>
          </div>
          <button className="btn btn-dark" type="button" onClick={saveTeam}>Save Team</button>
        </form>
      </>
    )
  }

  async function saveTeam () {
    // don't save id
    let tm = {
      bio: document.getElementById('inputTeamBio').value.split('\n'),
      name: document.getElementById('inputTeamName').value,
      nameAbbv: document.getElementById('inputTeamNameAbbv').value
    }
    
    await setDoc(doc(db, "teams", teamID), tm, { merge: true });
  }

  function createTeam () {
    navigate('/admin/teams/new');
  }

  if (dataReady == false || !team || team == {}) {
    return (
      <div className="Schedule">
        <LoadingAnimation />
      </div>
    )
  }
  else {
    return (
      <div className="Schedule">
        <div className="league-content">
          <div className="league-body">
            <p className='league-admin-back-button'><a className='league-link' href="/admin"><b>← Back to Admin Home</b></a></p>
            { teamID ? <p className='league-admin-back-button'><a className='league-link' href="/admin/teams"><b>← Back to Admin &gt; Teams</b></a></p> : '' }

            <p className="league-title-standard-secondary text-align-center">{ teamID ? "Edit Team" : "Create or Edit Team" }</p>
            { teamID ? '' : <a type="button" className="btn btn-dark" onClick={createTeam}>+ Create Team</a> }
            <div className="league-table-container schedule large-item-buttons-admin">
            {
                teamID ?
                displayEditTeam()
                :
                displayTeams()
              }
            </div>
          </div>
        </div>

        <Footer/>
      </div>
    );
  }
}

export default AdminTeams;
